export default __webpack_public_path__ + "static/media/holiday.e7a42a56.jpg";